import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { Modal } from '@applyboard/ui-components';
import { useEligibility } from "../../data";
import CheckEligibilityData from "./CheckEligibilityData";
var CheckEligibilityModal = function CheckEligibilityModal(_ref) {
  var studentId = _ref.studentId,
    programId = _ref.programId,
    onClose = _ref.onClose;
  var _useEligibility = useEligibility(Number(programId), Number(studentId)),
    eligibility = _useEligibility.eligibility,
    eligibilityError = _useEligibility.eligibilityError,
    isEligibilityLoading = _useEligibility.isEligibilityLoading;
  if (eligibilityError) {
    console.error({
      message: 'CheckEligibilityModal',
      eligibilityError: eligibilityError
    });
  }
  return /*#__PURE__*/React.createElement(Modal, {
    open: true,
    title: "Eligibility Result",
    handleClose: onClose
  }, isEligibilityLoading ? 'Loading...' : eligibilityError ? 'Cannot check eligibility' : /*#__PURE__*/React.createElement(CheckEligibilityData, {
    eligibility: eligibility
  }));
};
export default CheckEligibilityModal;